import styled from "styled-components";
export const Container = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
  overflow: hidden;
`;
export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 100px;
  @media (max-width: 575px) {
    margin: unset !important;
    align-items: center;
  }
`;

export const InnerTopContainer = styled.div``;

export const Heading = styled.h1`
  font-size: 65px;
  font-family: Poppins-SemiBold;
  color: #1d1d1d;
  text-align: center;
  @media (max-width: 575px) {
    font-size: 38px;
  }
`;
export const Description = styled.p`
  font-size: 32px;
  font-family: Poppins-Light;
  color: #1d1d1d;
  text-align: center;
  @media (max-width: 575px) {
    font-size: 18px;
  }
`;

export const BottomContainer = styled.div``;

export const ProjectsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 400px);
  grid-row-gap: 30px;
  margin-top: 100px;
  justify-items: center;

  @media (max-width: 575px) {
    grid-template-columns: repeat(auto-fill, 95%);
  }
`;

export const Card = styled.div`
  box-shadow: 5px 5px 8px #0000001f;
  border-radius: 0px 0px 15px 15px;
  width: fit-content;
  margin-left: 10px;
  margin-right: 10px;

  @media (max-width: 575px) {
    width: 80%;
  }
`;
export const CardInnerContainer = styled.div`
  padding: 15px;
`;

export const ImgContainer = styled.img`
  height: 250px;
  width: 100%;
  margin: auto;
  @media (max-width: 575px) {
    height: 200px;
  }
`;
export const Title = styled.h4`
  font-size: 18px;
  font-family: Poppins-Regular;
  color: #212121;
`;
export const Amount = styled.p`
  font-size: 14px;
  font-family: Poppins-Regular;
  color: #f2b017;
`;

export const Button = styled.button`
  width: 170px;
  height: 60px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 3px solid #565656;
  border-radius: 8px;
  opacity: 1;
  align-self: center;
  margin-top: 20px;
  cursor: pointer;
  margin-top: 50px;
`;
